let collapsed: boolean | null = null;

export const SIDEBAR_COLLAPSE_EVENT = 'sidebar:collapse';
export const SIDEBAR_EXPAND_EVENT = 'sidebar:expand';
export const SIDEBAR_TOGGLE_EVENT = 'sidebar:toggle';
export const SIDEBAR_CHANGED_EVENT = 'sidebar:changed';

function readInitial(): boolean {
  const saved = localStorage.getItem('sidebarCollapsed');
  if (saved === null) return false;
  try {
    return !!JSON.parse(saved);
  } catch (e) {
    // If localStorage got corrupted (e.g. manually edited), don't crash the app.
    console.warn('⚠️ Invalid sidebarCollapsed value in localStorage, resetting to false.', { saved });
    try {
      localStorage.setItem('sidebarCollapsed', JSON.stringify(false));
    } catch {
      // ignore
    }
    return false;
  }
}

export function getSidebarCollapsed(): boolean {
  if (collapsed === null) collapsed = readInitial();
  return collapsed;
}

function emitChanged(next: boolean) {
  document.dispatchEvent(new CustomEvent(SIDEBAR_CHANGED_EVENT, { detail: { collapsed: next } }));
}

export function setSidebarCollapsed(next: boolean) {
  collapsed = next;
  localStorage.setItem('sidebarCollapsed', JSON.stringify(next));
  emitChanged(next);
}

export function toggleSidebarCollapsed() {
  const next = !getSidebarCollapsed();
  setSidebarCollapsed(next);
}


